export default __webpack_public_path__ + "static/media/persona_2.964808dc.png";